import 'bootstrap'
// import 'data-confirm-modal'

document.addEventListener("turbo:load", function() {
  // $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
})
